import ProcessadorValorAutomatico from "../processadores/valores/ProcessadorValorAutomatico";
import ProcessadorDeValor from "../processadores/valores/ProcessadorValores";
import ProcessadorValorSimples from "../processadores/valores/ProcessadorValorSimples";
import ProcessadorValorCaixaDeChecagem from "../processadores/valores/ProcessadorValorCaixaDeChecagem";

export default class ConfigProcessadorValor {
    configurar(app) {
        const processadorValor = new ProcessadorDeValor();
        const processadorValorSimples = new ProcessadorValorSimples();
        processadorValor.registrarProcessador(
            "caixaDeTexto",
            "simples",
            processadorValorSimples,
        );
        processadorValor.registrarProcessador(
            "caixaDeTexto",
            "default",
            processadorValorSimples,
        );
        const processadorValorAutomatico = new ProcessadorValorAutomatico();
        processadorValor.registrarProcessador(
            "caixaDeTexto",
            "automatico",
            processadorValorAutomatico,
        );

        const processadorValorCaixaDeChecagem =
            new ProcessadorValorCaixaDeChecagem();
        processadorValor.registrarProcessador(
            "caixaDeChecagem",
            "default",
            processadorValorCaixaDeChecagem,
        );
        app.prototype.$processadorDeValor = processadorValor;
    }
}
